import type {
  CustomerSignUpReceipt,
  CustomerSignUpReceiptResponse,
  CustomerSignUpRequest,
} from '@mds/shared/types/customer';

import { api } from '@/lib/api';

/**
 * Sends the sign-up form into the CRM — see "Public sign-up" in
 * `backend/docs/customers.md`. Always `202`, whether the email was new or
 * already on file. Rate-limited per IP.
 */
export const signUp = (body: CustomerSignUpRequest): Promise<CustomerSignUpReceipt> =>
  api.post<CustomerSignUpReceiptResponse>('customers/sign-up', body).then((r) => r.data);
